import useDocument, { DocumentConfig } from './useDocument';
import { WorkOrder, WorkOrderStatus } from '../models/workOrder';

const config: DocumentConfig = {
  listKey: 'workOrders',
  detailKey: 'workOrder',
  basePath: 'WorkOrder',
  archivePath: (id) => `workorder/archive/${id}`,
  voidPath: (id) => `workorder/void/${id}`,
  voidType: 'WorkOrder', // EPIC_VOID_FLOW_2026-10
  unvoidPath: (id) => `workorder/UnVoid/${id}`, // item 553 — void is restorable
  statusPath: (id) => `workorder/setwostatus/${id}`,
  statusAsJson: true,
};

const useWorkOrder = (props: { id?: string }) => {
  const doc = useDocument<WorkOrderStatus, WorkOrder>(config, props);
  return { ...doc, tryChangeStatus: doc.tryStatus };
};

export default useWorkOrder;
